import { render, staticRenderFns } from "./scrolldown-tertiary.vue?vue&type=template&id=8b713126&scoped=true"
import script from "./scrolldown-tertiary.vue?vue&type=script&lang=js"
export * from "./scrolldown-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b713126",
  null
  
)

export default component.exports